"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceAreaEnvelope = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.ServiceAreaEnvelope = typebox_1.Type.Object({
    kml: typebox_1.Type.String(),
    geoJSON: typebox_1.Type.String(),
});
//# sourceMappingURL=service-area-envelope.js.map